import type { ReactNode } from "react";
import { InstagramIcon, LineIcon, MessengerIcon, TelegramIcon, TikTokIcon, WhatsAppIcon } from "@/components/admin_dashboard/BrandIcons";
import "./connect-mock.css";

// Same Google Calendar mark the landing page integrations list uses.
function GoogleCalendarMark() {
  return (
    <svg width="26" height="26" viewBox="3.5 3.5 17 17" aria-hidden>
      <path fill="#fff" d="M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" />
      <path fill="#4285f4" d="M6 4h8v2.500H6.500v11H4V6a2 2 0 0 1 2-2Z" />
      <path fill="#1967d2" d="M14 4l6 6V6a2 2 0 0 0-2-2z" />
      <path fill="#fbbc04" d="M17.500 10H20v8h-2.500z" />
      <path fill="#34a853" d="M6.500 17.500h11V20H6a2 2 0 0 1-2-2v-.500z" />
      <path fill="#ea4335" d="M17.500 17.500H20V18a2 2 0 0 1-2 2h-.500z" />
      <text x="12" y="16" textAnchor="middle" fontSize="7.500" fontWeight="700" fill="#4285f4" fontFamily="Plus Jakarta Sans, sans-serif">31</text>
    </svg>
  );
}

const channels: { name: string; icon: ReactNode }[] = [
  { name: "WhatsApp", icon: <WhatsAppIcon size={24} /> },
  { name: "Instagram", icon: <InstagramIcon size={24} /> },
  { name: "Telegram", icon: <TelegramIcon size={24} /> },
  { name: "Messenger", icon: <MessengerIcon size={24} /> },
  { name: "LINE", icon: <LineIcon size={24} /> },
  { name: "TikTok", icon: <TikTokIcon size={24} /> },
];

const tools: { name: string; icon: ReactNode }[] = [
  { name: "Tally", icon: <img className="cn-logo" src="/tally-icon.svg" alt="" width={26} height={26} /> },
  { name: "Acuity Scheduling", icon: <img className="cn-logo cn-logo--app" src="/acuity-icon.ico" alt="" width={26} height={26} /> },
  { name: "Google Calendar", icon: <GoogleCalendarMark /> },
];

function Row({ items, reverse }: { items: { name: string; icon: ReactNode }[]; reverse?: boolean }) {
  // Two identical halves, each wider than the viewport, so translating by -50% loops seamlessly.
  const half = [...items, ...items];
  return (
    <div className={`cn-row${reverse ? " cn-row--reverse" : ""}`}>
      <div className="cn-track">
        {[0, 1].map((copy) => (
          <div className="cn-half" key={copy} aria-hidden={copy === 1}>
            {half.map((item, i) => (
              <span className="cn-pill" key={i}><span className="cn-pill-icon">{item.icon}</span>{item.name}</span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

/** Two scrolling rows of the apps Dibs connects to: chat channels left to right, forms and booking tools right to left. */
export default function ConnectMock() {
  return (
    <div className="cn">
      <Row items={channels} />
      <Row items={tools} reverse />
    </div>
  );
}
